export default {
	name: "positionLost",
	data() {
		return {
			mapHref: "https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4&referer=myapp",
		};
	},
	mounted() {
		document.querySelector("body").classList.add("bg-fff");
		this.$once("hook:beforeDestroy", () => {
			document.querySelector("body").classList.remove("bg-fff");
		});
	},
	methods: {
		toSelectAddress() {
			let target = this.$route.query.target ? this.$route.query.target : localStorage.getItem("backHref");
			let href = `${location.origin}/yxd/community${target}`;
			let urlArr = href.split("?");
			this.mapHref = this.mapHref + `&backurl=${encodeURIComponent(href)}`;
			location.href = this.mapHref;
		},
	},
};
